import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tag } from '../../../interfaces/tag';
import { map, startWith } from 'rxjs/operators';
import { LoggerService } from '../../../services/logger.service';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';
import { OffersService } from '../../../services/offers.service';
import { isEqual } from 'lodash';
import { Router } from '@angular/router';
import { EventsService } from '../../../services/events.service';
import { TranslateService } from '@ngx-translate/core';
import * as stringSimilarity from 'string-similarity';
import { TagsServiceTypeEnum } from '../../../enums/tags-service-type.enum';

@Component({
  selector: 'app-tags-filter',
  templateUrl: './tags-filter.component.html',
  styleUrls: ['./tags-filter.component.scss']
})
export class TagsFilterComponent implements OnInit {
  @Output()
  activeTagsEvent = new EventEmitter<any>();
  @Input()
  serviceType: TagsServiceTypeEnum;
  @Input()
  dependantOnStatus = true;
  public tagList: Tag[] = [];
  public filteredOptions: Observable<Tag[]>;
  public formFilter: FormControl = new FormControl();
  public activeTags: Tag[] = [];
  public isOfferList: boolean;
  public currentStatus: string;

  constructor(
    private toastr: ToastsManager,
    private router: Router,
    private offersService: OffersService,
    private eventsService: EventsService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.isOfferList = this.router.url === '/offers';
    this.filteredOptions = this.formFilter.valueChanges.pipe(
      startWith(''),
      map(val => this.filter(val))
    );
    if (this.dependantOnStatus) {
      this.offersService.currentStatus$.subscribe(status => {
        if (!status || this.currentStatus === status) return;
        this.currentStatus = status;
        this.getFindTagsObservable({ offerStatus: this.currentStatus }).subscribe(
          tags => {
            this.tagList = tags;
            if (this.formFilter.value) {
              this.formFilter.setValue(this.formFilter.value);
            }
          },
          error => {
            LoggerService.log('TagsFilterComponent::ngOnInit::findTags', error);
            this.toastr.error(this.translate.instant('TAGS_FILTER.ERROR'));
          }
        );
      });
    } else {
      this.getFindTagsObservable({}).subscribe(
        tags => {
          this.tagList = tags;
        },
        error => {
          LoggerService.log('TagsFilterComponent::ngOnInit::findTags', error);
          this.toastr.error(this.translate.instant('TAGS_FILTER.ERROR'));
        }
      );
    }
  }

  getFindTagsObservable(query: object): Observable<Tag[]> {
    if (this.serviceType === TagsServiceTypeEnum.EVENTS) {
      return this.eventsService.findTags();
    }
    return this.offersService.findTags(query);
  }

  fillPlaceholder() {
    return this.serviceType === TagsServiceTypeEnum.OFFERS
      ? this.translate.instant('TAGS_FILTER.OFFERS')
      : this.translate.instant('TAGS_FILTER.METRICS');
  }

  toggleTag(tag: Tag): void {
    const tagIndex = this.activeTags.findIndex(activeTag => isEqual(activeTag, tag));
    if (tagIndex > -1) {
      this.activeTags.splice(tagIndex, 1);
    } else {
      this.activeTags.push(tag);
    }
    const activeTags = this.activeTags.map(activeTag => activeTag.value);
    const query = activeTags.length
      ? { 'tags.value': { $all: activeTags }, offerStatus: this.currentStatus }
      : { offerStatus: this.currentStatus };
    if (this.serviceType === TagsServiceTypeEnum.OFFERS) {
      this.offersService.findAllMatchingIds(query);
    }
    this.findTags(query);
    this.activeTagsEvent.emit(this.activeTags);
  }

  filter(val: string): Tag[] {
    return this.tagList
      .filter(option => {
        if (option.value) {
          return option.value
            .toLowerCase()
            .trim()
            .includes(val.toLowerCase());
        }
      })
      .map(tag => {
        return {
          ...tag,
          similarity: stringSimilarity.compareTwoStrings(val, tag.value)
        };
      })
      .sort((a, b) => (a.similarity < b.similarity ? 1 : -1));
  }

  findTags(query): void {
    this.getFindTagsObservable(query).subscribe(tags => {
      this.tagList = tags;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tags-filter/tags-filter.component.ts